import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_bedding_sheets: FaireCategoryEntity = {
  token: "cat_bedding-sheets",
  type: "category",
  name: "Sheets",
  level: 3,
  parentToken: "cat_home-decor-bedding",
  href: "/category/home-decor/bedding/sheets",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
